import React, { useState,useRef,useEffect } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';
import Loader from 'jd-library/Loader';
import { connect, shallowEqual, useSelector } from 'react-redux';
import axios from 'axios';
import './uploadLibraryImage.scss';
import Animation from '../../transition/Animation';
import config from '../../../../config/config';
import ImageLoader from '../../Image/ImageLazyWrapper';
import { toggleSearchImage } from '../../../actions/upload-options';
const apiDomain = config.apiDomains[0];
const staticImageDomains = config.staticImageDomains[0];
let CancelToken = axios.CancelToken;
let timeout;

const imageProps = {
	height: '100%',
	width:'100%',
	borderRadius: '4px'
}
const ShowUploadLibraryImage = React.forwardRef((props, ref) => {
    const getSliderOptions = ({uploadOptions}) => uploadOptions;
	const options = useSelector(getSliderOptions, shallowEqual);
	const inputRef = useRef(null);
	const [isSearching, setIsSearching] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [imageListData, setImageListData] = useState([]);
	const [showSlider, updateVisibility] = useState(true);
    const [inputFocus, setInputFocus] = useState(true);
	const [pageNo,updatePageNo] = useState(1);
	const [showPreview, setShowPreview] = useState(false);
	const [imagePreview,updateImagePreview] = useState([]);
	const [apiHit,updateApiHit] = useState(false);
	const [selectImage,updateSelectImage] = useState(null);
	const [isLoading, toggleLoading] = useState(false);

	const onSelectCallBack = (actualPath,imgSrc) =>{
		let param;
		if(props.type == 'itemCategory'){
            param ={
                imageUrl: imgSrc,
                module:'groups'
			}
			axios({
				method: 'GET',
				url: '/marketplace/products/ajax/uploadProductImageThroughUrl.service',
				params: param
			}).then((res) => {
				if(res.data.status == "success"){
					options.updateProductImage({imageUrl: res.data.imgURL,createdfrom:'libraryImages'})
				}
				historyHandler.closeCurrent();
			})
        }else{
			options.updateProductImage({imageUrl: actualPath,createdfrom:'libraryImages'})
			historyHandler.closeCurrent();
		}
	}

	// const onAttachmentClick = (url,actualPath) => {
	// 	let selectedImage = [{
	// 		previewUrl: url
	// 	}]
	// 	updateImagePreview(selectedImage);
	// 	setShowPreview(true);
	// 	let selectbutton = (<div className='select-image'> onClick={() =>{onSelectCallBack(actualPath)}}
	// 			Select Image
	// 	</div>)
	// 	updateSelectImage(selectbutton);
	// }
	const closeSlider = () => {
		props.toggle && props.toggle();
		historyHandler.closeCurrent();
	};
	let ImageList = list => {
        let imageList = [];
		for (let i = 0; i < list.length; i++) {
			let imageSrc = list[i] ? staticImageDomains + '/library' + list[i] : null;
			const onClick = e => {
				onSelectCallBack(list[i],imageSrc);
				//onAttachmentClick(imageSrc,list[i]);
				//onAttachmentClick('https://image1.jdomni.in/jdomni_email/searchV_1905081948.png');
			};
            const imageLoaderProps = {
                style: imageProps,
                finalImageSrc: imageSrc,
                loadOrignal : true
            }
			imageList.push(
                <div className='image-container'>
					<div className='image-holder' onClick={onClick}>
						<ImageLoader 
						{...imageLoaderProps}
					/>
					</div>
                </div>
			);
		}
		return imageList;
	};
    const closeKeypad = () => {
		// inputRef.current.blur();
		setInputFocus(false);
		document.getElementById('searchCategory').blur();
	};
	const onValChange = e => {
		let inputVal = e ? e.currentTarget.value : '';
		if(!apiHit){
			updateApiHit(true);
		}
        setSearchText(inputVal);
		//getData(inputVal);
		if (!e) {
			inputRef.current.focus();
		}
	};
	useEffect(()=>{
		if(apiHit){
			getData();
		}
	},[searchText]);

	let preCancelReq;
	const getData = (cb) => {
		// props.showHideLoader({
		// 	showLoader: true
		// });
		if(preCancelReq){
			preCancelReq.cancel({
				data:{isSuccess:false}
			})
		}
		preCancelReq = CancelToken.source();
		if(timeout){
			console.log(timeout);
			clearTimeout(timeout);
		}
		if(searchText){
			toggleLoading(true);
		}
		 timeout = setTimeout(() =>{
			let strUrl =
			apiDomain + `/marketplace/static/php/web/common_api.php?action=imageLibrary&pageNo=${pageNo}&keyword=${searchText ||
				''}`;
			axios.get(strUrl,{},{
				cancelToken:preCancelReq.token
			}).then(data => {
			if (data.data) {
                setImageListData(data.data.url);
			} else {
                setImageListData([]);
			}
			toggleLoading(false);
			if(searchText == ''){
				setIsSearching(false);
				setImageListData([]);
			}else{
				setIsSearching(true);
			}

			// props.showHideLoader({
			// 	showLoader: false
			// });
		});
		},500)
	};
	return options.sliderType == 'searchLibrary' && (
        <SliderWrapper
		slider={{
			className: 'library-image-slider',
			slideDirection: 'bottom',
			disableAnimation: true
		}}
		onHidden={
			()=>{
				props.toggleSearchImage({show: false})
			}
		}><Animation>
			{props.uploadLibrary && showSlider ? (<>
				<div
					className={
						'search-holder'
					}
				>
					<div className={'search-header'}>
						<div
							className={'icon-holder'}
							onClick={closeSlider}
						>
							<i
								className={'back-icon icon-HDRback'}
							/>
						</div>
						<input
							ref={inputRef}
							type='text'
							className={'search-input'}
							placeholder= 'Search Image'
							onChange={e => onValChange(e)}
							value={searchText}
							autoFocus
							autoComplete='off'
							id='searchCategory'
							onFocus={() => {setInputFocus(true);}}
							onBlur={() => {setInputFocus(false);}}
						/>
						{searchText && !isLoading && (
							<div
								className={'icon-holder'}
								onClick={() => onValChange()}
							>
								<i
									className={'clear-icon icon-HDRcross'}
								/>
							</div>
						)}
							{isLoading && (
								<div className={'icon-holder'}>
									<Loader
										className={'search-loader'}
									/>
								</div>
							)}
					</div>
                    {isSearching ?
					(<Animation>
						{imageListData.length ? (
							<div
								className={'result-holder'}
								onTouchMove={closeKeypad}
							>
								<div className={'prod-list'}>
									{ImageList(imageListData)}
								</div>
							</div>
						) : (
							<div
								className={
									'no-result-container'
								}
								onTouchMove={closeKeypad}
							> <div className = {`${
								(inputFocus && props.deviceData.isIphone) ? 'no-result-fixed': ''
							} ${'no-result-product'}`} >
								<img
									src='https://image1.jdomni.in/jdomni_email/searchV_1905081948.png'
									className={'no-result-img'}
								/>
								<h3
									className={
										'no-result-heading'
									}
								>
									No Results Found
								</h3>
								<div className='no-result-subheading'>Search in Google Images</div>
								</div>
							</div>
						)}
					</Animation>) : null }
				</div>
				{/* {showPreview ? 
					<DocumentPreview btnLeft={selectImage}imageList={imagePreview}  clickedImageIndex={0} showHideCb = {action => {action == 'hide' && setShowPreview(false)}}/>
				: null
				} */}
				</>
			) : null} 
			</Animation>
            </SliderWrapper>
	);
});

const mapStateToProps = (state, props) => {
	return {
		...props,
		deviceData: state.library.deviceData
	};
};

export default connect(mapStateToProps, {toggleSearchImage} ,null, { forwardRef: true })(
	ShowUploadLibraryImage
);

